export default __webpack_public_path__ + "static/media/Elec12.2c4a1e2c.png";